import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a412d2b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "Liste des devoirs soumis")
], -1))
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1))
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_8 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_12 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Étudiant "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Composition "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Fichier "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Soumission "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Statut "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Note "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
    }, " Actions ")
  ])
], -1))
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_23 = { class: "dropdown" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  style: {"cursor":"pointer"}
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1))
const _hoisted_25 = { class: "dropdown-menu" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, null, -1))
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_31 = {
  key: 3,
  class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          class: "search-box position-relative me-15",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher un devoir..."
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_5
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.devoirs.length === 0 && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Aucun devoir soumis. "))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        : (_ctx.devoirs.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devoirs, (devoir) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: devoir.id
                    }, [
                      _createElementVNode("td", _hoisted_14, _toDisplayString(devoir.etudiant?.prenom) + " " + _toDisplayString(devoir.etudiant?.nom), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(devoir.composition?.titre || '—'), 1),
                      _createElementVNode("td", _hoisted_16, [
                        _createElementVNode("small", null, _toDisplayString(_ctx.truncate(devoir.fichierNom, 25)), 1)
                      ]),
                      _createElementVNode("td", _hoisted_17, [
                        _createElementVNode("small", null, _toDisplayString(_ctx.formatDate(devoir.dateSoumission)), 1)
                      ]),
                      _createElementVNode("td", _hoisted_18, [
                        _createElementVNode("span", {
                          class: _normalizeClass([_ctx.getStatutBadge(devoir.statut), "badge"])
                        }, _toDisplayString(_ctx.formatStatut(devoir.statut)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_19, [
                        (devoir.note !== null && devoir.note !== undefined)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_20, _toDisplayString(devoir.note) + "/20 ", 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, "—"))
                      ]),
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("ul", _hoisted_25, [
                            (devoir.statut !== 'corrige' && devoir.composition?.type !== 'QCM')
                              ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'ViewDevoirPage', params: { id: devoir.id } },
                                    class: "dropdown-item d-flex align-items-center text-success"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_27,
                                      _createTextVNode(" Corriger ")
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_28,
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center text-danger",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.confirmDelete(devoir.id, devoir.fichierNom))
                              }, [
                                _hoisted_30,
                                _createTextVNode(" Supprimer ")
                              ], 8, _hoisted_29)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
      (_ctx.devoirs.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createVNode(_component_PaginationComponent, {
              page: _ctx.page,
              totalPages: _ctx.totalPages,
              totalElements: _ctx.totalElements,
              limit: _ctx.limit,
              onPaginate: _ctx.handlePaginate
            }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}